import React, { useEffect, useState } from 'react';
import { observer } from "mobx-react-lite";
import { Button, Dialog } from 'oned';
import { AmplitudeEventName } from '@common/enums/base';
import { inject } from 'mobx-react';
import { ProblemBusiness } from '@business/newCreateRequest/stepsItems/problem';
import { getCurrentEnv, sendAmplitude_Default } from '@common/utils';
import Cookies from "js-cookie";
var ICantFindMyIssue = inject(ProblemBusiness)(observer(function (props) {
    var currentUser = props.currentUser, level = props.level, problemCaseCadeName = props.problemCaseCadeName;
    var _a = useState(false), iCantFindMyIssueVisible = _a[0], setICantFindMyIssueVisible = _a[1];
    var sendAmplitude = function () {
        setICantFindMyIssueVisible(true);
        sendAmplitude_Default(AmplitudeEventName.NewRSP_CantFindIssue, {
            userId: currentUser.userId,
            residentId: currentUser.residentId,
            level: level,
            serviceCombo: problemCaseCadeName,
            clientId: Cookies.get('clientId'),
            env: getCurrentEnv(),
        });
    };
    useEffect(function () {
        setICantFindMyIssueVisible(false);
    }, [level]);
    return React.createElement(React.Fragment, null,
        React.createElement("div", { className: 'mt-4 mb-3 no-find' },
            React.createElement("a", { onClick: sendAmplitude }, "I can't find my issue")),
        React.createElement(Dialog, { visible: iCantFindMyIssueVisible, title: "I can't find my issue", closable: true, destroyOnClose: false, onClose: function () { return setICantFindMyIssueVisible(false); }, animation: "zoom", maskAnimation: "fade", hasFooter: false, className: "i-cant-find-my-issue-visible", onSubmit: function () {
                setICantFindMyIssueVisible(false);
            } },
            React.createElement("div", { className: 'f24 mt-1 dialog-body-title' },
                React.createElement("b", null,
                    "Can't find your issue? ",
                    React.createElement("span", { className: 'dialog-body-title-br' }),
                    "That's okay!")),
            React.createElement("div", { className: 'f16 mt-4' }, "Choose the closest issue option that resembles what you're experiencing and provide more details in the next step. If possible, add more details by uploading photos or videos. That will help us get you the right help."),
            React.createElement("div", { className: 'f16 mt-4 pb-3' }, "We will contact you if we have further questions. "),
            React.createElement("div", { className: 'mt-4 mb-4 continue-button' },
                React.createElement(Button, { onClick: function () { return setICantFindMyIssueVisible(false); } },
                    React.createElement("span", { className: 'f14' }, "Continue with request")))));
}));
export default ICantFindMyIssue;
